import {
  CHECK_EVENT_CALENDAR_CAN_BE_DELETED,
  CHECK_EVENT_CALENDAR_CAN_BE_DELETED_FAILED,
  CHECK_EVENT_CALENDAR_CAN_BE_DELETED_SUCCESS,
  CLONE_EVENT_CALENDAR,
  CLONE_EVENT_CALENDAR_FAILED,
  CLONE_EVENT_CALENDAR_SUCCESS,
  CREATE_EVENT_CALENDAR,
  CREATE_EVENT_CALENDAR_FAILED,
  CREATE_EVENT_CALENDAR_SUCCESS,
  DELETE_CALENDAR_EVENT,
  DELETE_CALENDAR_EVENT_FAILED,
  DELETE_CALENDAR_EVENT_SUCCESS,
  DELETE_EVENT_CALENDAR,
  DELETE_EVENT_CALENDAR_FAILED,
  DELETE_EVENT_CALENDAR_SUCCESS,
  GET_ALL_CALENDAR_EVENTS,
  GET_ALL_CALENDAR_EVENTS_FAILED,
  GET_ALL_CALENDAR_EVENTS_SUCCESS,
  GET_ALL_EVENTS_CALENDAR,
  GET_ALL_EVENTS_CALENDAR_FAILED,
  GET_ALL_EVENTS_CALENDAR_SUCCESS,
  GET_CALENDAR_EVENT,
  GET_CALENDAR_EVENT_FAILED,
  GET_CALENDAR_EVENT_SUCCESS,
  GET_EVENTS_CALENDAR,
  GET_EVENTS_CALENDAR_FAILED,
  GET_EVENTS_CALENDAR_SUCCESS,
  GET_EVENT_CALENDAR_GROUP,
  GET_EVENT_CALENDAR_GROUP_FAILED,
  GET_EVENT_CALENDAR_GROUP_SUCCESS,
  HIDE_CLONE_EVENT_CALENDAR_MODAL,
  HIDE_DELETE_CALENDAR_EVENT_MODAL,
  HIDE_DELETE_EVENT_CALENDAR_MODAL,
  OPEN_CLONE_EVENT_CALENDAR_MODAL,
  OPEN_DELETE_CALENDAR_EVENT_MODAL,
  OPEN_DELETE_EVENT_CALENDAR_MODAL,
  RESET_EVENT_CALENDAR_GROUP,
  UPDATE_EVENT_CALENDAR,
  UPDATE_EVENT_CALENDAR_FAILED,
  UPDATE_EVENT_CALENDAR_SUCCESS,
} from "./actionTypes"

export const getEventsCalendar = params => ({
  type: GET_EVENTS_CALENDAR,
  payload: params,
})

export const getEventsCalendarSuccess = response => ({
  type: GET_EVENTS_CALENDAR_SUCCESS,
  payload: response,
})

export const getEventsCalendarFailed = error => ({
  type: GET_EVENTS_CALENDAR_FAILED,
  payload: error,
})

export const getCalendarEvent = params => ({
  type: GET_CALENDAR_EVENT,
  payload: params,
})

export const getCalendarEventSuccess = response => ({
  type: GET_CALENDAR_EVENT_SUCCESS,
  payload: response,
})

export const getCalendarEventFailed = error => ({
  type: GET_CALENDAR_EVENT_FAILED,
  payload: error,
})

export const getAllEventsCalendar = params => ({
  type: GET_ALL_EVENTS_CALENDAR,
  payload: params,
})

export const getAllEventsCalendarSuccess = response => ({
  type: GET_ALL_EVENTS_CALENDAR_SUCCESS,
  payload: response,
})

export const getAllEventsCalendarFailed = error => ({
  type: GET_ALL_EVENTS_CALENDAR_FAILED,
  payload: error,
})

export const getAllCalendarEvents = params => ({
  type: GET_ALL_CALENDAR_EVENTS,
  payload: params,
})

export const getAllCalendarEventsSuccess = response => ({
  type: GET_ALL_CALENDAR_EVENTS_SUCCESS,
  payload: response,
})

export const getAllCalendarEventsFailed = error => ({
  type: GET_ALL_CALENDAR_EVENTS_FAILED,
  payload: error,
})

export const getEventCalendarGroup = params => ({
  type: GET_EVENT_CALENDAR_GROUP,
  payload: params,
})

export const getEventCalendarGroupSuccess = response => ({
  type: GET_EVENT_CALENDAR_GROUP_SUCCESS,
  payload: response,
})

export const getEventCalendarGroupFailed = error => ({
  type: GET_EVENT_CALENDAR_GROUP_FAILED,
  payload: error,
})

export const resetEventCalendarGroup = () => ({
  type: RESET_EVENT_CALENDAR_GROUP,
  payload: {},
})

export const createEventCalendar = params => ({
  type: CREATE_EVENT_CALENDAR,
  payload: params,
})

export const createEventCalendarSuccess = response => ({
  type: CREATE_EVENT_CALENDAR_SUCCESS,
  payload: response,
})

export const createEventCalendarFailed = error => ({
  type: CREATE_EVENT_CALENDAR_FAILED,
  payload: error,
})

export const updateEventCalendar = params => ({
  type: UPDATE_EVENT_CALENDAR,
  payload: params,
})

export const updateEventCalendarSuccess = response => ({
  type: UPDATE_EVENT_CALENDAR_SUCCESS,
  payload: response,
})

export const updateEventCalendarFailed = error => ({
  type: UPDATE_EVENT_CALENDAR_FAILED,
  payload: error,
})

export const deleteEventCalendar = params => ({
  type: DELETE_EVENT_CALENDAR,
  payload: params,
})

export const deleteEventCalendarSuccess = response => ({
  type: DELETE_EVENT_CALENDAR_SUCCESS,
  payload: response,
})

export const deleteEventCalendarFailed = error => ({
  type: DELETE_EVENT_CALENDAR_FAILED,
  payload: error,
})

export const openDeleteEventCalendarModal = () => ({
  type: OPEN_DELETE_EVENT_CALENDAR_MODAL,
  payload: {},
})

export const hideDeleteEventCalendarModal = () => ({
  type: HIDE_DELETE_EVENT_CALENDAR_MODAL,
  payload: {},
})

export const checkEventCalendarCanBeDeleted = params => ({
  type: CHECK_EVENT_CALENDAR_CAN_BE_DELETED,
  payload: params,
})

export const checkEventCalendarCanBeDeletedSuccess = response => ({
  type: CHECK_EVENT_CALENDAR_CAN_BE_DELETED_SUCCESS,
  payload: response,
})

export const checkEventCalendarCanBeDeletedFailed = error => ({
  type: CHECK_EVENT_CALENDAR_CAN_BE_DELETED_FAILED,
  payload: error,
})

export const openCloneEventCalendarModal = () => ({
  type: OPEN_CLONE_EVENT_CALENDAR_MODAL,
  payload: {},
})

export const hideCloneEventCalendarModal = () => ({
  type: HIDE_CLONE_EVENT_CALENDAR_MODAL,
  payload: {},
})

export const cloneEventCalendar = params => ({
  type: CLONE_EVENT_CALENDAR,
  payload: params,
})

export const cloneEventCalendarSuccess = response => ({
  type: CLONE_EVENT_CALENDAR_SUCCESS,
  payload: response,
})

export const cloneEventCalendarFailed = error => ({
  type: CLONE_EVENT_CALENDAR_FAILED,
  payload: error,
})

export const deleteCalendarEvent = params => ({
  type: DELETE_CALENDAR_EVENT,
  payload: params,
})

export const deleteCalendarEventSuccess = response => ({
  type: DELETE_CALENDAR_EVENT_SUCCESS,
  payload: response,
})

export const deleteCalendarEventFailed = error => ({
  type: DELETE_CALENDAR_EVENT_FAILED,
  payload: error,
})

export const openDeleteCalendarEventModal = () => ({
  type: OPEN_DELETE_CALENDAR_EVENT_MODAL,
  payload: {},
})

export const hideDeleteCalendarEventModal = () => ({
  type: HIDE_DELETE_CALENDAR_EVENT_MODAL,
  payload: {},
})
